// Kept apart from design-system.tsx and admin-ui.tsx so both can import it
// without a circular dependency.

/**
 * Title scale shared by the platform and the admin, so the same level reads
 * the same size everywhere: page (h1 in PageHeader), section (h2 blocks such
 * as "Sigue viendo", "Próximamente", settings and admin sections), featured
 * card (the overview lesson card) and card.
 */
export const titleClass = {
  page: "font-display text-4xl font-extrabold sm:text-5xl",
  section: "font-display text-3xl font-extrabold sm:text-4xl",
  featured: "font-display text-3xl font-extrabold",
  card: "font-display text-2xl font-extrabold",
} as const;
